import { CreateTxOptions } from '@terra-money/terra.js'
import { useConnectedWallet } from '@terra-money/wallet-provider'
import { useCallback } from 'react'
import { gatewayService } from 'services/gatewayService'
import useBroadcast from './useBroadcast'

const usePilotGatewayTx = () => {
  const connectedWallet = useConnectedWallet()

  const { send: _sendInvite, txStatus: txStatusInvite } = useBroadcast()
  const sendInvite = useCallback(
    (address: string, options?: CreateTxOptions) => {
      if (!connectedWallet) return

      const txs = {
        ...gatewayService.invite(connectedWallet.walletAddress, address),
        ...options,
      }
      _sendInvite(txs, `Invite ${address}`)
    },
    [_sendInvite, connectedWallet],
  )

  return { sendInvite, txStatusInvite }
}

export default usePilotGatewayTx
